/**
 * The allowed image domains for the NextJS image component from [MicroLibraryCoreUI](https://dev.azure.com/orcha/MicroLibraryTemplate/_git/MicroLibraryCoreUI)
 *
 * @type {Object}
 * @property {string[]} domains - The allowed image domains.
 */
export const allowedImageDomains = {
  domains: [
    'orcha-images.s3.amazonaws.com',
    'orcha-app-library-images-uat.s3.eu-west-2.amazonaws.com',
    'orcha-images.s3.eu-west-2.amazonaws.com',
    'storchageneraldev.blob.core.windows.net',
    'strsharedproduksouth.blob.core.windows.net',
    'play-lh.googleusercontent.com',
  ],
};
